module.exports = __webpack_public_path__ + "static/media/waaa.c2985557.ogg";